import { ChipProps } from '@mui/material';

import { EntryRewardStatus } from 'v2/constants';

export const rewardColorByStatus: Record<EntryRewardStatus, ChipProps['color']> = {
  [EntryRewardStatus.ACTIVE]: 'success',
  [EntryRewardStatus.EXPIRED]: 'error',
  [EntryRewardStatus.CREATED]: 'info',
};
